import React from 'react';
import { View, Pressable, StyleSheet, Image } from 'react-native';

import { COLOR, FONT, FONT_SIZE, THEME, __WEB__ } from '../../../../constants/styles';

import OPComponent from '../../op_component';
import Utils from '../../../../utils';
import ImagePicker from './image_picker';

export default class Toolbar extends OPComponent {
  constructor(props) {
    super(props);
  }

  openImagePicker = () => {
    Utils.trackEvent('Navigation', 'Load', 'Image Picker');
    ImagePicker.selectImage().then(({ image }) => {
      this.props.onAddFromImagePicker?.({ image });
    });
  };

  openCamera = () => {
    Utils.trackEvent('Navigation', 'Load', 'Camera');
    ImagePicker.takePhoto()
      .then(({ image }) => {
        this.props.onAddFromCamera?.({ image });
      })
      .catch((e) => {
        // console.info('>>> error from camera')
      });
  };

  render() {
    return (
      <View style={styles.container}>
        <Pressable style={[styles.button, styles.farLeftButton]} onPress={this.openImagePicker}>
          <Image style={styles.icon} source={require('../../../../../resources/icon-photo.png')} />
        </Pressable>

        {!__WEB__ && (
          <Pressable style={styles.button} onPress={this.openCamera}>
            <Image
              style={styles.icon}
              source={require('../../../../../resources/icon-camera.png')}
            />
          </Pressable>
        )}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    ...THEME.container,
    flexDirection: 'row',
  },
  button: {
    paddingLeft: 15,
    paddingRight: 15,
    paddingVertical: 12,
    // backgroundColor: 'pink'
  },
  farLeftButton: {
    paddingLeft: 0,
  },
  icon: {
    width: 24,
    height: 24,
    tintColor: COLOR.textLight,
  },
});

Toolbar.defaultProps = {
  addComment: true,
  onAddFromCamera: null,
  onAddFromImagePicker: null,
};
